import { useCallback, useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

export const useSearchParamsState = <T>() => {
    const [params, setParams] = useSearchParams();

    const paramsData = useMemo(() => {
        const formattedParams = {} as T;
        params.forEach((value, key) => {
            formattedParams[key] = value;
        });
        return formattedParams;
    }, [params]);

    const handleSetParam = useCallback(
        (key: keyof T, value?: string) => {
            if (value === undefined) {
                params.delete(key as string);
            } else {
                params.set(key as string, value);
            }
            setParams(params, { replace: true });
        },
        [params, setParams],
    );

    const handleDeleteParam = useCallback(
        (key: keyof T) => {
            handleSetParam(key);
        },
        [handleSetParam],
    );
    return { params: paramsData, setParams: handleSetParam, removeParam: handleDeleteParam };
};
